import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Chip, Link as MUILink, Paper, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import formatCurrency from '@/shared/utils/formatCurrency';
import formatDate from '@/shared/utils/formatDate';

type WaveUIStatusPanelProps = {
  id: string;
  statuses: string[];
  total: string;
  created: string;
  href?: string;
};

const WaveUIStatusPanel: FC<WaveUIStatusPanelProps> = ({
  id,
  statuses,
  total,
  created,
  href,
}) => {
  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        boxShadow: 3,
        p: 2,
      }}
    >
      <Stack>
        <MUILink
          component={Link}
          to={href || '#'}
          variant='body1'
          underline='none'
          sx={{
            width: 75,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          #{id}
        </MUILink>
        <Typography variant='body2'>{formatDate(created)}</Typography>
      </Stack>

      <Stack direction='row' spacing={1}>
        {statuses.map((status) => (
          <Chip
            key={status}
            label={status}
            color='default'
            size='medium'
            sx={{ textTransform: 'lowercase' }}
          />
        ))}
      </Stack>

      <Typography variant='body2' sx={{ ml: 'auto' }}>
        {formatCurrency(Number(total))}
      </Typography>
    </Paper>
  );
};

export default WaveUIStatusPanel;
